<template>
    <div :class="['card-wrap', { 'noMargin': isQYZ || isYZH }, { 'bg-b': isYZH }]" @click.stop="showDetail(item)">
        <div class="card" :style="cardStyle" @mousemove="handleMouseMove" @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave" ref="card">
            <!-- :style="cardBgTransform" -->
            <div class="card-bg">
                <img :src="item" alt="" :style="{ width: `${getImgWidth(item) / divisor}px` }" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'image-card',
    props: ['item', 'divisor', 'isQYZ', 'isYZH'],
    data() {
        return {
            width: 0,
            height: 0,
            mouseX: 0,
            mouseY: 0,
            mouseLeaveDelay: null,
        }
    },
    computed: {
        mousePX() {
            return this.mouseX / this.width;
        },
        mousePY() {
            return this.mouseY / this.height;
        },
        cardStyle() {
            const rX = this.mousePX * 20;
            const rY = this.mousePY * -20;
            return { transform: `rotateY(${rX}deg) rotateX(${rY}deg)` }
        },
        cardBgTransform() {
            const tX = this.mousePX * 60;
            const tY = this.mousePY * -60;
            return { transform: `translateX(${tX}px) translateY(${tY}px)` }
        }
    },
    mounted() {
        this.width = this.$refs.card.offsetWidth;
        this.height = this.$refs.card.offsetHeight;
    },
    methods: {
        getImgWidth(url) {
            let paths = url.split('/');
            let width = paths[paths.length - 1].split('_')[1].split('.')[0];
            return width;
        },
        showDetail(item) {
            this.$emit('showDetail', item);
        },
        handleMouseMove(e) {
            // console.log(e)
            // console.dir(this.$refs.card)
            // this.mouseX = e.pageX - this.$refs.card.offsetLeft - this.width / 2;
            // this.mouseY = e.pageY - this.$refs.card.offsetTop - this.height / 2;
            this.mouseX = e.layerX - this.width / 2;
            this.mouseY = e.layerY - this.height / 2;
            // const rect = this.$refs.card.getBoundingClientRect();
            // console.log(rect)
            // this.mouseX = e.clientX - rect.left - this.width / 2;
            // this.mouseY = e.clientY - rect.top - this.height / 2;
        },
        handleMouseEnter() {
            clearTimeout(this.mouseLeaveDelay);
        },
        handleMouseLeave() {
            this.mouseLeaveDelay = setTimeout(() => {
                this.mouseX = 0;
                this.mouseY = 0;
            }, 1000);
        }
    }
}
</script>
<style scoped>
.card-wrap {
    position: relative;
    display: inline-block;
    margin-right: 15px;
    margin-bottom: 10px;
    /* -webkit-transform: perspective(100px);
    transform: perspective(100px); */
    -webkit-transform-style: preserve-3d;
    transform-style: preserve-3d;
    cursor: pointer;
}

.noMargin {
    margin: 0;
}

.card {
    position: relative;
    -webkit-box-flex: 0;
    /* -ms-flex: 0 0 200px;
    flex: 0 0 200px; */
    overflow: hidden;
    border-radius: 4px;
    -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    background-color: transparent;
    border: none;
}

.card-bg {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 2s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 2s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    pointer-events: none;
}

.card-wrap:hover {
    position: relative;
    z-index: 2;
}

.card-wrap:hover .card-bg {
    -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 2s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), opacity 2s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    opacity: 0.8;
}

.card-wrap:hover .card {
    scale: 2;
    -webkit-transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), box-shadow 2s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95), box-shadow 2s cubic-bezier(0.445, 0.05, 0.55, 0.95);
    box-shadow: rgba(255, 255, 255, 0.2) 0 0 2px 2px, white 0 0 0 3px, rgba(0, 0, 0, 0.66) 0 2px 2px 0, inset #333 0 0 0 3px, inset white 0 0 0 3px;
}

.noMargin:hover .card {
    background-color: #fff;
}

.bg-b:hover .card { 
    scale: 3;
    background-color: rgba(58,65,109, 0.5);
    box-shadow: rgba(230, 181, 105, 0.2) 0 0 2px 2px, rgba(192, 126, 58, 0.66) 0 0 0 3px, rgba(192, 126, 58, 0.66) 0 2px 2px 0, inset rgba(230, 181, 105) 0 0 0 3px, inset white 0 0 0 3px;
}
</style>
